import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/support")({
  staticData: { title: "Support" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/support/page.tsx"),
    "Support",
  ),
})
